import React, { useEffect } from "react";
import { MenuItem } from "@material-ui/core";
import I18nText from "../../../elements/I18nText";
import { ROLES, useAuth } from "../../../auth";
import { DEVICE_SMS_GATEWAY_TYPE, DEVICE_TYPE } from "../../../domain/device";
import FullWidthSelect from "../../../elements/FormField/FullWidthSelect";
import { useFormikContext } from "formik";

const DeviceTypeSelector = ({ onSelectType, selectedType }) => {
  const fieldName = "device-type-label";
  const { user, hasRole } = useAuth();
  const { values, setFieldValue } = useFormikContext();
  // If user is not MASTER, she cannot choose; Lionel is the only option
  if (!hasRole(user, ROLES.MASTER)) {
    return null;
  }

  useEffect(() => {
    if (values[fieldName]) {
      onSelectType(values[fieldName]);
    }
  }, [values[fieldName]]);

  return (
    <FullWidthSelect
      variant="outlined"
      name={fieldName}
      inputProps={{
        value: values[fieldName] ?? selectedType
      }}
      label={<I18nText>devices.common.type</I18nText>}
    >
      <MenuItem value={DEVICE_SMS_GATEWAY_TYPE.LIONEL}>
        <I18nText>devices.common.smsGatewayTypes.lionel</I18nText>
      </MenuItem>
      <MenuItem value={DEVICE_SMS_GATEWAY_TYPE.ONCE}>
        <I18nText>devices.common.smsGatewayTypes.1nce</I18nText>
      </MenuItem>
      <MenuItem value={DEVICE_TYPE.IOT}>
        <I18nText>devices.common.typeOptions.iot</I18nText>
      </MenuItem>
      <MenuItem value={DEVICE_TYPE.LX_IOT}>
        <I18nText>devices.common.typeOptions.lx_iot</I18nText>
      </MenuItem>
      <MenuItem value={DEVICE_TYPE.NET}>
        <I18nText>devices.common.typeOptions.net</I18nText>
      </MenuItem>
    </FullWidthSelect>
  );
};

export default DeviceTypeSelector;
